// import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
// import { Action } from 'redux';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { ENotificationType } from '../../types/notifications';
import { IThunkApi } from '../../types/redux';
import { getModerationComplainMicrofrontend } from 'shared/services/complaint/getModerationComplainMicrofrontend';
import { addNotification, complainActions } from 'shared/slices';

export const getComplaints = createAsyncThunk<void, void, IThunkApi>('complain/getComplaints', async (_, thunkApi) => {
  const {
    dispatch,
    extra: { microfrontendsRegistry, logger, httpApi },
  } = thunkApi;

  return getModerationComplainMicrofrontend({ httpApi, logger })
    .then(manifest => {
      if (manifest) {
        microfrontendsRegistry.register(manifest);
      }
      dispatch(complainActions.complainDataFetched({ manifest }));
    })
    .catch(() => {
      dispatch(complainActions.complainFailRequest({ isError: true }));
      dispatch(addNotification({ type: ENotificationType.Error, text: 'Не удалось загрузить виджет' }));
    });
});
